const guiColors = {
    'motion-primary': '#80f51b',
    'motion-primary-transparent': 'hsla(92, 92%, 53%, 0.35)',
    'motion-tertiary': '#68c616',
    'motion-primary-dark': '#7ed200',
	
	'looks-secondary': '#80f51b', // bright green
    'looks-secondary-light': '#aaff60', // bright green
    'looks-secondary-lighter': '#d1ffa8', // bright green
    'looks-transparent': '#80f51b59', // more transparent green
    'looks-light-transparent': '#aaff6026', // very transparent green
    'looks-secondary-dark': '#7ed200', // dark green
    'looks-secondary-darker': '#599302', // dark green
    'looks-secondary-deep-dark': '#385c01', // dark green

    'extensions-primary': '#80f51b',
    'extensions-tertiary': '#68c616',
    'extensions-transparent': 'hsla(92, 91%, 53%, 0.35)',
    'extensions-light': '#89ee30',

    'drop-highlight': 'hsl(92,100%,71%)'
};

const blockColors = {
    checkboxActiveBackground: '#80f51b', // bright green
    checkboxActiveBorder: '#5ab70a' // darker green
};

export {
    guiColors,
    blockColors
};
